import styled from 'styled-components';

export const StyledCard = styled('div')(({ theme: { colors, spacing } }) => ({
    backgroundColor: colors.white,
    borderRadius: spacing(2),
    boxShadow: 'none',
    padding: spacing(2),
}));
